'use client';

import './account-button.scss';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@radix-ui/react-dropdown-menu';
import { useTranslation } from 'react-i18next';

import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.js';
import { Link } from '@sola/ark-core/atoms/link/link.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';
import { AuthStatusEnum, useAuth } from '@sola/auth-sdk/store.js';
import { getPublicConfig } from '@sola/config/lib/getters.js';
import { trackClick } from '@sola/cookies/components/datalayer.js';

export interface AccountButtonProps {
  simple?: boolean;
}

export const AccountButton: React.FC<AccountButtonProps> = ({ simple }) => {
  const { t } = useTranslation();
  const { actions: authActions } = useAuth('actions');

  const { currentStatus: currentAuthStatus } = useAuth('currentStatus');

  const logOut = async () => {
    trackClick(t('priority:nav.logOut'));
    authActions.logOut();
  };

  const { NEXT_PUBLIC_BASE_URL_MYACCOUNT } = getPublicConfig();

  return currentAuthStatus !== AuthStatusEnum.Authenticated || simple ? (
    <Link
      type="button"
      href={NEXT_PUBLIC_BASE_URL_MYACCOUNT || '#'}
      className="AccountButton__avatar flex p-comfy-xs"
      title={t('priority:header.myAccount')}
    >
      <ArkIcon iconName="user-01" className="AccountButton__icon" />
    </Link>
  ) : (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="AccountButton__avatar flex p-comfy-xs"
          title={t('priority:header.myAccount')}
        >
          <ArkIcon iconName="user-01" className="AccountButton__icon" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="AccountButton__menu flex flex-col items-end mt-snug-lg py-snug-xl"
      >
        <DropdownMenuItem className="flex w-full align-start">
          <span className="flex px-comfy-sm py-snug-xl gap-comfy-xs items-center">
            <ArkIcon
              iconName="home-03"
              className="AccountButton__icon--small"
            />
            <LinkStyle noUnderline noPadding purpose="neutral">
              <Link
                href={NEXT_PUBLIC_BASE_URL_MYACCOUNT || '#'}
                className="AccountButton__menu-item w-full py-comfy-xs px-comfy-sm"
              >
                {t('checkout.nav.goToMyAccount')}
              </Link>
            </LinkStyle>
          </span>
        </DropdownMenuItem>
        <DropdownMenuItem className="flex w-full align-start">
          <span className="flex px-comfy-sm py-snug-xl gap-comfy-xs items-center">
            <ArkIcon
              iconName="log-out-01"
              className="AccountButton__icon--small"
            />
            <LinkStyle noUnderline noPadding purpose="negative">
              <button type="button" onClick={logOut}>
                {t('priority:nav.logOut')}
              </button>
            </LinkStyle>
          </span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
